// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"TablaOperario__headerRow___3rjYu","evenRow":"TablaOperario__evenRow___oBXFb","oddRow":"TablaOperario__oddRow___2d0qu","headerColumn":"TablaOperario__headerColumn___1QKOR","headerRowAPI":"TablaOperario__headerRowAPI___2qiWb","evenRowAPI":"TablaOperario__evenRowAPI___3mnVH","oddRowAPI":"TablaOperario__oddRowAPI___2CeMD","headerColumnAPI":"TablaOperario__headerColumnAPI___mzE61","celdaAPI":"TablaOperario__celdaAPI___1ak1l","celdaAPILider":"TablaOperario__celdaAPILider___38si7"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/nominas/nominaIG/components/TablaOperario.css
// module id = 922
// module chunks = 0